import React, { useContext } from 'react';
import { AppContext } from '../main';


// const payments = {
//   title: "We accept",
//   subtitle: "Payment Methods",
//   payments: [
//     { name: "Visa", src: "./img/payments/visa.webp" },
//     { name: "MasterCard", src: "./img/payments/mastercard.webp" },
//     { name: "PayPal", src: "./img/payments/paypal.webp" },
//     { name: "Skrill", src: "./img/payments/skrill.webp" },
//     { name: "JCB", src: "./img/payments/jcb.webp" },
//     { name: "American Express", src: "./img/payments/american-express.webp" }
//   ]
// };

const Payment = (props) => {
    const {
        handleEditItem
    } = props
    const { appState
    } = useContext(AppContext);
    const {
        payments = {},
        editMode = false
    } = appState

    if (!payments?.payments?.[0]) {
        return null
    }

    return <div className="container">
        <div className="row align-items-center">
            <div className="col-lg-6">
                <div className="subtitle wow fadeInUp mb-3">{payments.subtitle}</div>
                <h2 className="wow fadeInUp" data-wow-delay=".2s">{payments.title}</h2>
            </div>
            <div className="col-lg-6">
                <div className="row g-4">
                    {payments.payments.map((method, index) => (
                        <div key={index} className="col-sm-2 col-4">
                            <div className="p-2 rounded-10 bg-half-white">
                                <img width="70" height="50" src={method.src} className="img-fluid" alt={method.name} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
};

export default Payment;
